<template>
  <v-list-tile
    @click="$store.commit('toggleTheme')">
    <v-list-tile-action><v-icon>invert_colors</v-icon></v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title>{{ $t(isDarkTheme ? 'modo-dia' : 'modo-noche') }}</v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
import Cookie from 'js-cookie'
export default {
  created() {
    const isDark = JSON.parse(Cookie.get('isDarkTheme') || null)

    const isLightTheme = isDark === false

    if(this.isDarkTheme && isLightTheme) {
      this.$store.commit('toggleTheme')
    }
  },

  computed: {
    isDarkTheme() {
      return this.$store.getters.isDarkTheme
    }
  },

  watch: {
    isDarkTheme(isDark) {
      Cookie.set('isDarkTheme', JSON.stringify(isDark))
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectTheme.vue?98096b7a